<template>
    <el-drawer
        title="上传支付凭证"
        :visible.sync="showUploadPayVoucher"
        :wrapperClosable="true"
        :append-to-body="true"
    >
        <el-form ref="formRef" :rules="rules" :model="form">
        <el-form-item label="上传支付凭证" prop="paymentVoucherUrl">
            <UploadCommon
            :isAlone="false"
            listType="img"
            :limit="1"
            :fileList="form.paymentVoucherUrl"
            :commonUpload="true"
            group="finance"
            code="finance_payment_voucher"
            ></UploadCommon>
        </el-form-item>
        </el-form>

        <div class="bottom-btn">
        <el-divider></el-divider>
        <el-button @click="showUploadPayVoucher = false">取消</el-button>
        <el-button
            class="submit-btn"
            type="primary"
            :loading="submitLoading"
            @click="submitUploadPayVoucher">确定支付完成</el-button>
        </div>
    </el-drawer>
</template>

<script setup>
import { ref, getCurrentInstance, watchEffect } from 'vue'
import { Message } from '@qs/ui'
import { submitCommitPaymentVoucher } from '@/api/domain/purchase'
import { useSubmitLock } from '@/utils/useUtils'

const props = defineProps({
  orderId: {
    type: String,
    default: '',
  },
})
const emit = defineEmits(['uploadCommitPaymentVoucherSucc'])

const { orderId } = props

const vm = getCurrentInstance().proxy

// 上传付款凭证抽屉
const formRef = ref(null)
const showUploadPayVoucher = ref(false)

const { loading: submitLoading, run } = useSubmitLock()

const form = ref({
  paymentVoucherUrl: [],
})
const rules = {
  paymentVoucherUrl: [
    { required: true, message: '请上传支付凭证', trigger: 'change' },
  ],
}

const open = () => {
  showUploadPayVoucher.value = true
}

const submitUploadPayVoucher = () => {
  formRef.value.validate((valid) => {
    if (!valid) return
    run(async () => {
      const { code } = await submitCommitPaymentVoucher({
        orderId,
        paymentVoucherUrl: vm.getUoloadCommonFileData(form.value.paymentVoucherUrl),
      })
      if (code === 1) {
        showUploadPayVoucher.value = false
        emit('uploadCommitPaymentVoucherSucc')
        Message.success('提交成功')
      }
    })
  })
}

watchEffect(() => {
  if (!showUploadPayVoucher.value) {
    formRef.value?.resetFields()
  }
})

watchEffect(() => {
  if (form.value.paymentVoucherUrl.length) {
    formRef.value?.validateField('paymentVoucherUrl')
  }
})

defineExpose({
  open,
})
</script>

<style lang="scss" scoped>
::v-deep .upload-box {
    margin-top: 10px;
}
</style>
